import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { getProjectFolders } from 'scenes/ProjectBank/services/getProjectFolders.service';
import { loadUsersAndPersonalResourcesByUserIds } from 'store/projectUsers/thunks/loadUsersAndPersonalResourcesByUserIds';
import { uniq } from 'lodash';

export const loadProjectFolders = createAsyncThunk(
  'projectBank/loadProjectFolders',
  async (_, { getState, dispatch, rejectWithValue }) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    // The bank shows a gallery-only user their part of it, so it asks for
    // that view: the root and the images folder's subtree, their uploaders
    // left out where the user may not see them.
    const projectFolders = await getProjectFolders(selectedProjectId, {
      galleryView: true,
    });

    // The bank holds one project's folders at a time: an answer for a
    // project the user has since left (a quick hop from one bank to
    // another) must not land in the new project's tree.
    if (selectSelectedProjectId(getState()) !== selectedProjectId) {
      return rejectWithValue({ stale: true, projectId: selectedProjectId });
    }

    if (projectFolders && projectFolders.length > 0) {
      // A folder whose uploader the API left out names nobody to load.
      const uniqueUserIds = uniq(
        projectFolders.map((folder) => folder.user).filter(Boolean)
      );

      dispatch(loadUsersAndPersonalResourcesByUserIds(uniqueUserIds));
    }

    return projectFolders;
  }
);
